<template>
  <div class="container">
    <div class="notice">
      Silahkan Masukkan Data
      <span v-show="bank_code != 2">{{ bank_name }}</span> Anda
    </div>
    <div class="hello mb-2">
      <div class="content-left">
        <img :src="bank_img" alt="" />
      </div>
      <div class="content-right">
        <form>
          <!--
            =========
            form cimb
            =========
          -->
          <div class="form-group" v-show="bank_code == 1 || bank_code == 4">
            <label for="">No Rekening CIMB</label>
            <input
              type="text"
              class="form-input"
              placeholder="No Rekening CIMB"
              v-model="form.etb_account_no"
              @keyup="form.etb_account_no = form.etb_account_no.replace(/[^\d]/g, '')"
            />
            <div v-show="status == 200" class="succes">
              Akun pos pay anda valid
              <p>
                <router-link to="/register-datapribadi" class="router-link">Lanjut ke tahap selanjutnya</router-link>
              </p>
            </div>
          </div>

          <div class="form-group">
            <label for="">Nama Lengkap</label>
            <input
              type="text"
              class="form-input"
              placeholder="Nama Lengkap Anda"
              v-model="$v.form.fullname.$model"
              @keyup="form.fullname = form.fullname.replace(/[^a-zA-Z\s]/g, '')"
            />
            <div v-if="$v.form.fullname.$error">
              <div class="error" v-if="!$v.form.fullname.required">
                Nama lengkap tidak boleh kosong
              </div>
              <div class="error" v-if="!$v.form.fullname.maxLength">
                No KTP maksimal 40 karakter
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">No KTP</label>
            <input
              type="text"
              class="form-input"
              placeholder="No KTP Anda"
              v-model.trim="$v.form.ktp_no.$model"
              @keyup="form.ktp_no = form.ktp_no.replace(/[^\d]/g, '')"
            />
            <div v-if="$v.form.ktp_no.$error">
              <div class="error" v-if="!$v.form.ktp_no.required">
                No KTP tidak boleh kosong
              </div>
              <div class="error" v-if="!$v.form.ktp_no.maxLength">
                No KTP maksimal 16 karakter
              </div>
              <div class="error" v-if="!$v.form.ktp_no.minLength">
                No KTP minimal 16 karakter
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Tanggal Lahir</label>
            <input type="date" class="form-input birthday" v-model="$v.form.date_of_birth.$model" :max="today" />
            <div v-if="$v.form.date_of_birth.$error">
              <div class="error" v-if="!$v.form.date_of_birth.required">
                Tanggal Lahir tidak boleh kosong
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Nama Ibu</label>
            <input
              type="text"
              class="form-input"
              placeholder="Masukkan nama Ibu kandung"
              v-model.trim="$v.form.mothers_name.$model"
              @keyup="form.mothers_name = form.mothers_name.replace(/[^a-zA-Z\s]/g, '')"
            />
            <div v-if="$v.form.mothers_name.$error">
              <div class="error" v-if="!$v.form.mothers_name.required">
                Nama ibu tidak boleh kosong
              </div>
              <div class="error" v-if="!$v.form.mothers_name.maxLength">
                maksimal 20 karakter
              </div>
            </div>
            <div class="error" v-show="submited && !form.mothers_name">
              No Rekening tidak boleh kosong
            </div>
          </div>
          <div v-show="message" class="error">
            {{ message }}
          </div>
          <button class="btn-primer" type="button" @click="verifInput">
            Submit
          </button>
        </form>
      </div>
      <b-modal ref="modal-verifikasi">
        <h4 class="mb-1">Periksa Kembali Data Anda</h4>
        <h6 class="mb-3">Pastikan data yang anda masukkan sudah benar</h6>

        <table>
          <tr>
            <td style="width: 100px">Nama</td>
            <td style="width: 10px">:</td>
            <td>{{ form.fullname }}</td>
          </tr>
          <tr>
            <td>Tanggal Lahir</td>
            <td>:</td>
            <td>{{ form.date_of_birth }}</td>
          </tr>
          <tr>
            <td>No KTP</td>
            <td>:</td>
            <td>{{ form.ktp_no }}</td>
          </tr>
          <tr v-show="bank_code == 1 || bank_code == 4">
            <td>No Rekening</td>
            <td>:</td>
            <td>{{ form.etb_account_no }}</td>
          </tr>
          <tr>
            <td>Nama Ibu</td>
            <td>:</td>
            <td>{{ form.mothers_name }}</td>
          </tr>
        </table>

        <template #modal-footer>
          <button class="btn-primer" type="button" @click="login" :disabled="isLoading">
            <loading v-if="isLoading" />
            <span v-else>Submit</span>
          </button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import Loading from "../assets/Loading.vue";
import moment from "moment";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      form: {
        etb_account_no: "",
        fullname: "",
        date_of_birth: "",
        mothers_name: "",
        ktp_no: "",
        is_syariah: false,
      },
      status: "",
      isLoading: false,
      bank_code: "",
      bank_name: "",
      bank_img: "",
      api_url: "",
      message: "",
      submited: false,
      today: "",
      status_kyc: "",
      bankType: "",
    };
  },
  validations: {
    form: {
      fullname: {
        required,
        maxLength: maxLength(40),
      },
      date_of_birth: {
        required,
      },
      mothers_name: {
        required,
        maxLength: maxLength(20),
      },
      ktp_no: {
        required,
        maxLength: maxLength(16),
        minLength: minLength(16),
      },
    },
  },
  mounted() {
    var today = new Date();
    today.setFullYear(today.getFullYear() - 17);
    this.today = today.toISOString().split("T")[0];
    this.bank_code = localStorage.getItem("code");
    this.$store.dispatch("getCustomer");
    if (this.customer) {
      this.form.fullname = this.customer.customer.fullname;
      this.form.ktp_no = this.customer.customer.ktp_no;
      this.form.mothers_name = this.customer.customer.mothers_name;
      this.form.date_of_birth = moment(this.customer.customer.date_of_birth).format("YYYY-MM-DD");
      this.bankType = this.customer.bankType;
      this.status_kyc = this.customer.status_kyc;
      let id = this.customer._id;
      this.bank_name = "BANK ARTHA GRAHA";
      this.bank_img = require("@/assets/logo-agi-vertical.png");
      this.api_url = "/v1/nasabah/bagi/" + id;
    } else {
      if (this.bank_code == 1) {
        this.bank_name = "CIMB NIAGA";
        this.bank_img = require("@/assets/logo_cimb_niaga.png");
        this.api_url = "/v1/nasabah/cimb";
        this.form.is_syariah = false;
      } else if (this.bank_code == 2 || this.bankType == "BAGI") {
        this.bank_name = "BANK ARTHA GRAHA";
        this.bank_img = require("@/assets/logo-agi-vertical.png");
        this.api_url = "/v1/nasabah/bagi";
      } else if (this.bank_code == 4) {
        this.bank_name = "BANK CIMB SYARIAH";
        this.bank_img = require("@/assets/cimb-syariah.png");
        this.api_url = "/v1/nasabah/cimb";
        this.form.is_syariah = true;
      } else {
        this.bank_name = "BANK OCBC";
        this.bank_img = require("@/assets/logo_ocbc.png");
      }
    }
  },
  computed: {
    customer() {
      return this.$store.state.dataCustomer;
    },
    bank_type() {
      return this.bankType;
    },
  },
  methods: {
    verifInput() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.$refs["modal-verifikasi"].show();
    },
    login() {
      this.submited = true;
      this.isLoading = true;

      this.message = "";
      let methode;
      if (this.customer) {
        methode = {
          url: this.api_url,
          method: "PUT",
          data: this.form,
        };
      } else {
        methode = {
          url: this.api_url,
          method: "POST",
          data: this.form,
        };
      }
      axios(methode)
        .then((rsp) => {
          let status = rsp.data.data.status_code;
          if (status == "00") {
            this.isLoading = false;
            localStorage.setItem("flag_account", 1);
            this.$notify({
              group: "foo",
              title: "<h5>Selamat, Akun anda berhasil didaftarkan</h5>",
              type: "success",
              duration: 2000,
            });
            setTimeout(() => this.$router.push("/register-datapribadi"), 2000);
          } else if (status == 2001) {
            this.isLoading = false;
            this.$notify({
              group: "foo",
              title: "<h5>No KTP Sudah Terdaftar</h5>",
              type: "error",
              duration: 2000,
            });
          } else if (status == 2002) {
            this.isLoading = false;
            this.$notify({
              group: "foo",
              title: "<h5>Akun Sudah Terdaftar</h5>",
              type: "error",
              duration: 2000,
            });
          } else if (status == 9001) {
            this.isLoading = false;
            this.$notify({
              group: "foo",
              title: "<h5>Pastikan data yang anda masukkan benar</h5>",
              type: "error",
              duration: 2000,
            });
          } else if (status == 2010) {
            this.isLoading = false;
            this.$notify({
              group: "foo",
              title: "<h5>KTP Number rejected by the system!</h5>",
              type: "error",
              duration: 2000,
            });
          } else {
            this.isLoading = false;
            this.$notify({
              group: "foo",
              title: "<h5>Kesalahan sistem</h5>",
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.status = err.response.status;
          if (this.status == 400) {
            this.message = err.response.data.message;
          }
        });
    },
    isNumber(event) {
      const pattern = /[0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    },
    isAlphabet(event) {
      const pattern = /^[a-zA-Z\s]*$/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    },
    isAlphabetSymbol(event) {
      const pattern = /^[a-zA-Z0-9\s,.-]*$/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
a {
  color: #707070;
  text-decoration: none;
}

.router-link {
  color: #ff6f00;
  font-weight: bold;
  margin: 10px 0px;
}

.error {
  margin-bottom: 30px;
  padding: 0;
}

.container {
  width: 70%;
}

.hello {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  gap: 3rem;
  padding: 25px;
  font-size: 14px;
  border-radius: 5px;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
}

.content-left {
  flex: 1;
  text-align: right;
}

.content-left img {
  height: 12rem;
  margin: 0 10px;
}

.content-left p {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  margin: 20px 0 0;
  color: rgba(112, 112, 112, 0.5);
}

.content-right {
  flex: 2;
}

.form-input {
  width: 100%;
  padding: 0 15px;
  /* text-transform: capitalize; */
}

.notice-congrat {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  margin: 0 0 -15px;
}

.notice {
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  margin: 50px auto 0;
  background: var(--primary);
  color: #fff;
  padding: 25px;
  text-align: center;
  border-radius: 10px 10px 0 0;
  width: 80%;
}

.icon {
  color: #1524eb;
  font-size: 29px;
  position: absolute;
  left: 34%;
}

.birthday {
  text-transform: lowercase;
}

label {
  display: block;
}

select {
  width: 100%;
  height: 50px;
  border-radius: 15px;
  border: solid 2px rgba(112, 112, 112, 0.5);
  text-transform: capitalize;
}

select::first-letter,
select::first-line {
  text-transform: uppercase;
}
</style>
